export const Y1564_RUNNING_CHART_CONFIG = {
  series: [
    {
      id: 1,
      name: 'IR',
      unit: 'Mbps',
      field: 'ir-current',
      sla: 'target-ir',
      isHide: false
    },
    {
      id: 2,
      name: 'FLR',
      unit: '%',
      field: 'frame-loss-ratio',
      sla: 'frame-loss-ratio-threshold',
      isHide: false
    },
    {
      id: 3,
      name: 'FD',
      unit: 'ms',
      field: 'fd-current',
      sla: 'frame-delay-threshold',
      isHide: false
    },
    {
      id: 4,
      name: 'FDV',
      unit: 'ms',
      field: 'fdv-current',
      sla: 'latency-FDV-maximum',
      isHide: false
    }
  ]
};
